import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FaqCardComponent } from './faq-card/faq-card.component';
import { RouterModule } from '@angular/router';
import { BaseComponent } from './base/base.component';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from './spinner/spinner/spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
    declarations: [HeaderComponent, FaqCardComponent, BaseComponent, SpinnerComponent],
    imports: [CommonModule, SharedModule, RouterModule, FormsModule,NgxSpinnerModule],
    exports: [FaqCardComponent],
})
export class PartialsModule {}
